// remixWarnings.json
const REMIX_WARNINGS = {
  title: "Remix IDE — Cómo evitar warnings y errores comunes",
  sections: [
    {
      id: "intro",
      heading: "Evitar warnings en Remix",
      text: `Al programar en Remix IDE es frecuente que aparezcan advertencias (warnings) que distraen más de lo que ayudan. 
Uno de los más molestos es el mensaje: "compilerMetadata is modifying..." que se repite en cada línea de código cuando está activada la compilación automática.`
    },
    {
      id: "problema",
      heading: "¿Por qué aparece?",
      list: [
        "La compilación automática recompila tu contrato cada vez que modificas el archivo.",
        "Con las últimas versiones de Remix, este proceso muestra un warning de metadata en el compilador.",
        "El resultado es que verás el mismo aviso múltiples veces, dificultando trabajar sin distracciones."
      ]
    },
    {
      id: "solucion",
      heading: "Cómo evitarlo",
      list: [
        "Abre la pestaña **Solidity Compiler** en Remix.",
        "Localiza la opción **Auto Compile**.",
        "Desactiva la casilla de Auto Compile."
      ],
      note: `A partir de este momento ya no se mostrará el warning repetitivo.`
    },
    {
      id: "recomendacion",
      heading: "Recomendación práctica",
      list: [
        "Trabaja con Auto Compile desactivado para evitar spam de warnings.",
        "Cuando termines un bloque de cambios importantes, compila manualmente pulsando el botón **Compile**.",
        "Antes de desplegar tu contrato (Deploy & Run), asegúrate siempre de compilar manualmente para generar el bytecode actualizado."
      ],
      note: `Desactivar Auto Compile no afecta el resultado final; solo mejora la experiencia de desarrollo evitando advertencias innecesarias.`
    }
  ]
};

export default REMIX_WARNINGS;
